import type { CSSProperties } from 'react';

/** Styles inline — prioritaires sur le CSS (cache / conflits mobile iOS). */
export const MOBILE_PUBLIC_DRAWER_OVERLAY_STYLE: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 200,
};

export const MOBILE_PUBLIC_DRAWER_PANEL_STYLE: CSSProperties = {
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 'auto',
  zIndex: 210,
  display: 'flex',
  flexDirection: 'column',
  width: 'min(20rem, 100vw)',
  maxWidth: '100vw',
  margin: 0,
  boxSizing: 'border-box',
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
};

/** Bloque le scroll sans décaler les éléments fixed (bug iOS avec body.overflow). */
export function lockPublicMobileMenuScroll(): () => void {
  const html = document.documentElement;
  const body = document.body;
  const prevHtmlOverflow = html.style.overflow;
  const prevBodyOverflow = body.style.overflow;
  const prevBodyPaddingRight = body.style.paddingRight;

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  html.style.overflow = 'hidden';
  body.style.overflow = 'hidden';
  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;
  }

  return () => {
    html.style.overflow = prevHtmlOverflow;
    body.style.overflow = prevBodyOverflow;
    body.style.paddingRight = prevBodyPaddingRight;
  };
}
